import style from 'components/Video.module.scss'
import Img from 'gatsby-image'
import React, { useState } from 'react'
import { useInView } from 'react-intersection-observer'
import ReactPlayer from 'react-player'

const Video = ({ posterImage, videoUrl }) => {
  const [isActive, setIsActive] = useState(false)
  const [isReady, setIsReady] = useState(false)

  const handleClick = () => {
    setIsActive(true)
  }

  const PlayButton = () => {
    return (
      <button className={style.playButton} type="button" onClick={handleClick}>
        <svg
          width="35"
          height="46"
          viewBox="0 0 35 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 0L34.8961 22.531L0 45.062V0Z" fill="white" />
        </svg>
      </button>
    )
  }

  return (
    <div className={style.root}>
      <div className={style.playerWrapper}>
        {(!isActive || (isActive && !isReady)) && (
          <div className={style.poster}>
            {!!posterImage && <Img fluid={posterImage?.fluid} />}
            <PlayButton />
          </div>
        )}
        {isActive && (
          <ReactPlayer
            url={videoUrl}
            width="100%"
            height="100%"
            className={style.player}
            playing
            playsinline
            controls
            stopOnUnmount
            onReady={() => {
              setIsReady(true)
            }}
            onEnded={() => {
              setIsActive(false)
              setIsReady(false)
            }}
          />
        )}
      </div>
    </div>
  )
}

export default Video
